<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="props.width"
      :height="props.height"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M16 13L21 17.74L16 22.4799"
        :stroke="color"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script setup>
  const props = defineProps({
    width: {
      type: [Number, String],
      default: 7,
    },
    height: {
      type: [Number, String],
      default: 11,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  })
</script>

<script>
  export default {
    name: 'ArrowRight',
  }
</script>

<style lang="scss" scoped></style>
